var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("报名培训中心")]),_c('Table',{staticClass:"table",attrs:{"border":"","columns":_vm.columns3,"data":_vm.SignTrainInfos}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }